<style>
	:global(body) {
		padding: 0;
		overflow: hidden;
		background: linear-gradient(to right, #642b73, #c6426e);
	}

	/* .floating-bar {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		background-color: rgba(255,255,255,0.4);
		padding: 0.25rem 0.5rem;
	} */
</style>

<script>
	import { rounds, timeOn, timeOff, totalTime, playSounds } from './configStore'; 
	import Screen from './layout/Screen.svelte';
	import IntervalTimer from './IntervalTimer.svelte';
	import Overview from './Overview.svelte';

	// app state
	let screen = 'start'; // start | timer

	function startTimer() {
		screen = 'timer';
	}

	function back() {
		screen = 'start';
	}
</script>
<!-- <div class="floating-bar">
	<pre>{$playSounds}</pre>
</div> -->
{#if screen === 'timer'}
	<IntervalTimer rounds={$rounds} timeOn={$timeOn} timeOff={$timeOff} totalTime={$totalTime} sounds={$playSounds} on:reset={back} />
{/if}
{#if screen === 'start'}
	<Screen>
		<Overview on:start={startTimer} />
	</Screen>
{/if}

